(function () {
    'use strict';

    // @ngInject
    function BulkWorkspaceEmailsControllerCtor($scope, $injector, ModalService, $log, UsersManager, moment, PopupMessageService, AnalyticsService, $translate) {
        this.constructor.$super.call(this, $scope, $injector);
        this.__objectType = 'BulkWorkspaceEmailsController';

        AnalyticsService.trackPageView(this, 'bulk workspace emails');
        this.$log = $log;
        this.moment = moment;

        this.UsersManager = UsersManager;
        this.PopupMessageService = PopupMessageService;
        this.ModalService = ModalService;
        this.UsersManager = UsersManager;
        this.$translate = $translate;

        this.user = this.UsersManager.getCurrUser();

        this.bulkWorkspaceEmailsSentList = null;

        this.userSentBulkWorkspaceEmailsBefore = false;
        this.isLoading = true;

        this.emptyState = {
            title: $translate.instant('BATCH_EMAILS.LAST_SENT._TITLE_'),
            body: $translate.instant('BATCH_EMAILS.LAST_SENT._DESCRIPTION_'),
            cta: $translate.instant('BATCH_EMAILS.LAST_SENT._CREATE_BUTTON_')
        };

        this.sortingModel = {
            currentSorting: null,

            subject: {
                sortName: 'subject',
                sortKey: 'subject',
                serverSortKey: 'subject',
                sortReverse: false,
                sortByLabel: 'BATCH_EMAILS.LAST_SENT._SUBJECT_'
            },

            last_sent_time: {
                sortName: 'lastSentTime',
                sortKey: 'last_sent_time',
                serverSortKey: 'last_sent_time',
                sortReverse: true,
                sortByLabel: 'BATCH_EMAILS.LAST_SENT._DATE_SENT_'
            },

            serialize: function () {
                return {sortName: this.currentSorting.sortName, sortReverse: this.currentSorting.sortReverse};
            },

            deserialize: function (serialization) {
                this.currentSorting = this[serialization.sortName];
                this.currentSorting.sortReverse = serialization.sortReverse;
            }
        };

        this.getBulkWorkspaceEmailsHistory();
    }

    Controllers.BulkWorkspaceEmailsController = Class(Controllers.BaseController, {
        constructor: BulkWorkspaceEmailsControllerCtor,

        getBulkWorkspaceEmailsHistory: function getBulkWorkspaceEmalsHitory() {
            this.bulkWorkspaceEmailsPromise = this.UsersManager.getBulkWorkspaceEmails(this.user._id)
                .then(function success(resp) {

                    if (resp.data.batch_emails) {
                        this.bulkWorkspaceEmailsSentList = angular.copy(resp.data.batch_emails);
                        this.userSentBulkWorkspaceEmailsBefore = this.bulkWorkspaceEmailsSentList.length > 0;
                        this.setSort(this.sortingModel.last_sent_time, true);
                    }
                    this.isLoading = false;

                    return resp;
                }.bind(this))
                .catch(function fail(resp) {
                    console.log("resp");
                    console.log(resp);
                    this.isLoading = false;
                    this.PopupMessageService.showAlert(this.PopupMessageService.severityTypes.error, 'ERRORS.SERVER_API._COULD_NOT_CONNECT_TO_SERVER_');
                }.bind(this))
            ;
        },

        createBulkWorkspaceEmails: function createBulkWorkspaceEmails() {
            console.log("createBulkWorkspaceEmails");

            // this.batchEmailsPromise
            //     .then(function success(resp) {
            //         if (resp.data.allowed) {
            //             //the user could be blocked if he does not have gmail integration
            //             this.ModalService.openSendBatchEmailModal()
            //                 .then(function success() {
            //                     this.getBatchEmailsHistory();
            //                 }.bind(this), function dismissed(){
            //                     this.getBatchEmailsHistory();
            //                 }.bind(this));
            //
            //             //if you the user canceled we exit this flow quietly
            //         } else {
            //             if (resp.data.reason === 'premium_feature_only') {
            //                 this.ModalService.openConfirmPremiumFeature();
            //             } else if (resp.data.reason === 'unsupported_email_intg' || resp.data.reason === 'gmail_is_not_selected') {
            //                 this.ModalService.openConfirmGmailIntegrationNeeded();
            //             } else if (resp.data.reason === 'cannot_send_more_then_twice_a_day') {
            //                 this.PopupMessageService.showAlert(this.PopupMessageService.severityTypes.info, 'BATCH_EMAILS.LAST_SENT._CANNOT_SEND_MORE_THEN_TWICE_A_DAY_');
            //             }
            //             else {
            //                 this.PopupMessageService.showAlert(this.PopupMessageService.severityTypes.error, 'ERRORS.SERVER_API._UNEXPECTED_');
            //             }
            //         }
            //     }.bind(this))
            //     .catch(function (res) {
            //         if (res && res.data && res.data.error_message) {
            //             this.PopupMessageService.showAlert(this.PopupMessageService.severityTypes.info, res.data.error_message);
            //         } else {
            //             this.PopupMessageService.showAlert(this.PopupMessageService.severityTypes.error, 'ERRORS.SERVER_API._UNEXPECTED_');
            //         }
            //     }.bind(this))
        },

        sortIt: function (sortingModel, sortReverse) {
            // Reverse the sort if needed
            if (this.sortingModel.currentSorting.sortKey === sortingModel.sortKey) {
                sortingModel.sortReverse = !sortingModel.sortReverse;
            }
            this.setSort(sortingModel);
        },

        setSort: function (sortingModel) {
            this.sortingModel.currentSorting = sortingModel;
        }
    });
}());
